import type { auditReports } from '@mi-front/api-clients';
import { QueriesView } from '@mi-front/ui';
import { Box } from '@mui/material';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
import { Page } from '../../../../../../components/page/Page';
import { ReportDefinitionsBreadcrumbs } from '../../../../components/breadcrumbs';
import { reportNameMessages } from '../../constants';
import { ReportDefinitionEditor } from './components/ReportDefinitionEditor';
import { CloneButton } from './components/actions/CloneButton';
import { DeleteButton } from './components/actions/DeleteButton';
import { DefinitionContextProvider } from './contexts/DefinitionContext';
import { useReportDefinitionQuery } from './hooks/useReportDefinitionQuery';

export function ReportDefinitionEditorPage() {
  const { $t } = useIntl();
  const params = useParams<{ id: string }>();
  const id = params.id;

  const { blueprintQuery, definitionQuery } = useReportDefinitionQuery(id);

  const title = $t({
    id: 'audit.reportDefinitionEditor.title',
    defaultMessage: 'Plantilla de reporte',
  });

  return (
    <QueriesView<
      [
        auditReports.GetBlueprintMetadataMetadataQueryResponse,
        auditReports.GetReportDefinitionByIdQueryResponse,
      ]
    >
      queries={[blueprintQuery, definitionQuery]}
    >
      {([blueprint, definition]) => {
        const reportNameMessage = reportNameMessages[blueprint.reportType];
        const reportName = reportNameMessage ? $t(reportNameMessage) : blueprint.reportType;

        return (
          <DefinitionContextProvider
            blueprint={blueprint}
            initialDefinition={definition}
            languages={['es']}
          >
            <Page htmlTitle={title}>
              <Page.Header
                title={
                  <>
                    {title}: {reportName && <span style={{ opacity: 0.7 }}>{reportName}</span>}
                  </>
                }
                breadcrumbs={<ReportDefinitionsBreadcrumbs reportType={blueprint.reportType} />}
                actions={
                  <Box display="flex" gap={2}>
                    <CloneButton />
                    <DeleteButton />
                  </Box>
                }
              />
              <Page.Content>
                <ReportDefinitionEditor
                  blueprint={blueprint}
                  definition={definition}
                  languages={['es']}
                />
              </Page.Content>
            </Page>
          </DefinitionContextProvider>
        );
      }}
    </QueriesView>
  );
}
